var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0902 38.7911H36.1029C35.1251 38.7909 34.2281 37.9761 34.2281 36.9167C34.2284 36.0202 34.881 35.287 35.7768 35.1239C36.3475 35.0424 36.7549 34.472 36.5918 33.9014C36.3475 32.7605 37.2439 31.6198 38.3849 31.6198C39.1185 31.6196 39.7704 32.027 40.0149 32.6792C40.2597 33.2495 41.0738 33.4126 41.5635 33.0051C42.3786 32.353 43.6003 32.9236 43.6003 33.983C43.6005 34.5533 43.9271 34.9608 44.4153 35.0423C45.312 35.2054 45.8824 35.9389 45.8824 36.8352C45.9641 37.8946 45.1489 38.7911 44.0902 38.7911ZM45.6388 33.3311C45.2312 31.4565 43.1929 30.2342 41.319 30.8863C40.5856 30.0713 39.5252 29.5823 38.3849 29.5823C36.2658 29.5823 34.5543 31.2936 34.4736 33.3311C33.0881 33.983 32.1914 35.287 32.1914 36.8352C32.1916 38.954 33.9031 40.7471 36.1029 40.7471L44.0902 40.7469C46.2093 40.7469 48.0015 39.0356 48.0015 36.8352C48.0015 35.2868 47.0234 33.9014 45.6388 33.3311Z",
    fill: "url(#paint0_linear_486_1491)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1389 26.5669H21.0262V25.5075L24.1231 23.3072L27.2204 25.5075V26.5669H27.1389ZM21.0262 41.8064V38.7096H27.1389V41.8064H21.0262ZM27.1389 31.6195H21.0262V28.5229H27.1389V31.6195ZM21.0262 33.657H27.1389V36.7536H21.0262V33.657ZM17.0332 25.8335L19.4783 18.3362C19.6407 17.9287 19.4783 17.4397 19.07 17.1952L12.7136 12.5499H20.6186C21.0262 12.5499 21.4345 12.3055 21.5967 11.8167L24.0417 4.31915L26.4868 11.8164C26.6499 12.2239 26.9758 12.5502 27.4649 12.5502L35.3698 12.5499L28.932 17.1952C28.6059 17.4397 28.4428 17.9287 28.5244 18.3362L30.9695 25.8335L29.0949 24.4481V22.4922C29.0949 21.9219 28.6059 21.4328 28.0354 21.4328C27.4649 21.4328 26.9758 21.9219 26.9758 22.4922V22.9812L24.5308 21.1884C24.2048 20.9438 23.7158 20.944 23.3081 21.1884L20.864 22.9812V22.4922C20.864 21.9219 20.3749 21.4328 19.8042 21.4328C19.234 21.4328 18.7449 21.9219 18.7449 22.4922V24.4481L17.0332 25.8335ZM3.99364 13.2833C3.01553 13.2833 2.1191 12.4686 2.1191 11.4092C2.1191 10.5127 2.77101 9.77924 3.66768 9.61638C4.23817 9.53483 4.64558 8.96425 4.48272 8.39389C4.23819 7.25295 5.13463 6.11198 6.27492 6.11198C7.00942 6.11198 7.66111 6.51946 7.90495 7.17136C8.15016 7.74172 8.9645 7.90484 9.45355 7.49734C10.2686 6.84544 11.491 7.41579 11.491 8.47542C11.491 9.04578 11.8172 9.45326 12.306 9.5348C12.8767 9.61612 13.2841 9.94232 13.5286 10.4311H9.53522C9.12851 10.4311 8.71996 10.6758 8.55779 11.1646C8.394 11.5721 8.55779 12.0611 8.9645 12.3055L10.2686 13.202H3.99364V13.2833ZM32.355 29.3379C32.5181 29.5007 32.7626 29.5007 32.9255 29.5007C33.5769 29.5007 34.1472 28.8488 33.9036 28.1969L30.7242 18.4175L39.0375 12.3871C39.3635 12.1424 39.5257 11.6536 39.4449 11.2461C39.282 10.8386 38.9559 10.5127 38.4668 10.5127H28.1975L25.0198 0.733446C24.8567 0.325951 24.5308 0 24.0417 0C23.6341 0 23.2267 0.244405 23.0636 0.733446L19.8859 10.5127H15.7291C15.4034 9.29017 14.5882 8.31232 13.4472 7.82328C13.0398 5.94889 11.0019 4.72663 9.12828 5.37853C8.39401 4.56354 7.33446 4.07474 6.19417 4.07474C4.07531 4.07451 2.36363 5.78603 2.28197 7.82328C0.896695 8.47518 0 9.77924 0 11.3277C0 13.4465 1.71148 15.2393 3.912 15.2393H11.8986C12.2246 15.2393 12.5505 15.2393 12.8765 15.1577L17.2777 18.3362L14.0991 28.1154C13.9362 28.5229 14.0991 29.0119 14.5067 29.2563C14.8327 29.5007 15.3217 29.5007 15.7291 29.2563L18.908 26.8929V46.859C18.908 47.4296 19.3968 47.9184 19.9673 47.9184C20.538 47.9184 21.0262 47.4296 21.0262 46.859V43.8437H27.1389V46.9406C27.1389 47.5109 27.6277 48 28.1975 48C28.7683 48 29.2578 47.5109 29.2578 46.9406L29.258 26.9744L32.355 29.3379Z",
    fill: "url(#paint1_linear_486_1491)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.70397 29.5824C4.56323 29.5824 3.66654 28.6858 3.66654 27.5451C3.66654 26.4042 4.563 25.5076 5.70397 25.5076C6.84426 25.5076 7.74071 26.4042 7.74071 27.5451C7.74071 28.6858 6.84426 29.5824 5.70397 29.5824ZM5.70397 23.4704C3.42202 23.4704 1.62891 25.2632 1.62891 27.5451C1.62913 29.8268 3.42202 31.6199 5.70397 31.6199C7.98547 31.6196 9.77837 29.8268 9.77837 27.5451C9.77837 25.2632 7.98524 23.4704 5.70397 23.4704Z",
    fill: "url(#paint2_linear_486_1491)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8891 19.3956C42.1343 19.3956 42.3788 19.64 42.3788 19.8847C42.3788 20.1291 42.1343 20.3734 41.8891 20.3734C41.6445 20.3734 41.4007 20.1291 41.4007 19.8847C41.4009 19.64 41.5638 19.3956 41.8891 19.3956ZM41.8891 22.4922C43.2755 22.4922 44.4156 21.3513 44.4156 19.966C44.4158 18.5806 43.2753 17.4396 41.8891 17.4396C40.5036 17.4396 39.3633 18.5806 39.3633 19.966C39.3633 21.3513 40.5033 22.4922 41.8891 22.4922Z",
    fill: "url(#paint3_linear_486_1491)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2886 3.09665C35.8591 3.09665 36.3472 3.58568 36.3472 4.15604C36.3475 4.72662 35.8591 5.21569 35.2886 5.21569C34.7174 5.21546 34.2281 4.72662 34.2281 4.15604C34.2284 3.58568 34.7172 3.09665 35.2886 3.09665ZM35.2886 7.17135C36.9994 7.17135 38.3849 5.78603 38.3849 4.07473C38.3849 2.3632 36.9994 0.977844 35.2886 0.977844C33.5765 0.977844 32.1914 2.44474 32.1914 4.15604C32.1916 5.86757 33.5762 7.17135 35.2886 7.17135Z",
    fill: "url(#paint4_linear_486_1491)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3254 44.8215C37.9112 44.8215 38.3847 45.296 38.3847 45.8812C38.3847 46.4661 37.911 46.9406 37.3252 46.9406C36.7403 46.9406 36.2656 46.4663 36.2656 45.8812C36.2656 45.2958 36.74 44.8218 37.3254 44.8215Z",
    fill: "url(#paint5_linear_486_1491)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3254 23.4704C37.9112 23.4704 38.3847 23.9447 38.3847 24.5298C38.3847 25.115 37.911 25.5892 37.3252 25.5892C36.7403 25.5892 36.2656 25.115 36.2656 24.5298C36.2656 23.9447 36.74 23.4704 37.3254 23.4704Z",
    fill: "url(#paint6_linear_486_1491)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4417 12.224C44.0275 12.224 44.5019 12.6985 44.5019 13.2836C44.5019 13.8685 44.0275 14.343 43.4417 14.343C42.8575 14.3428 42.3828 13.8685 42.3828 13.2836C42.3828 12.6982 42.8572 12.224 43.4417 12.224Z",
    fill: "url(#paint7_linear_486_1491)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9502 2.0373C17.5353 2.0373 18.0097 2.51159 18.0097 3.09673C18.0097 3.68187 17.5351 4.15611 16.9502 4.15611C16.365 4.15611 15.8906 3.68187 15.8906 3.09673C15.8906 2.51159 16.365 2.0373 16.9502 2.0373Z",
    fill: "url(#paint8_linear_486_1491)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7783 18.3362C10.3634 18.3362 10.8379 18.8104 10.8379 19.3956C10.8381 19.9807 10.3634 20.455 9.7783 20.455C9.19317 20.4547 8.71875 19.9807 8.71875 19.3956C8.71898 18.8104 9.19317 18.3362 9.7783 18.3362Z",
    fill: "url(#paint9_linear_486_1491)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.915 34.6349C15.5001 34.6349 15.9745 35.1093 15.9745 35.6943C15.9748 36.2794 15.5001 36.7536 14.915 36.7536C14.3301 36.7536 13.8555 36.2794 13.8555 35.6943C13.8557 35.1091 14.3299 34.6349 14.915 34.6349Z",
    fill: "url(#paint10_linear_486_1491)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74223 40.7468C8.32736 40.7468 8.80178 41.2212 8.80178 41.8064C8.80201 42.3913 8.32736 42.8658 7.74223 42.8658C7.15733 42.8658 6.68359 42.3915 6.68359 41.8064C6.68382 41.2212 7.15733 40.747 7.74223 40.7468Z",
    fill: "url(#paint11_linear_486_1491)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_486_1491",
    x1: 40.0965,
    y1: 29.5823,
    x2: 40.0965,
    y2: 40.7471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_486_1491",
    x1: 19.7327,
    y1: 0,
    x2: 19.7327,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_486_1491",
    x1: 5.70364,
    y1: 23.4704,
    x2: 5.70364,
    y2: 31.6199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_486_1491",
    x1: 41.8894,
    y1: 17.4396,
    x2: 41.8894,
    y2: 22.4922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_486_1491",
    x1: 35.2881,
    y1: 0.977844,
    x2: 35.2881,
    y2: 7.17135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_486_1491",
    x1: 37.3252,
    y1: 44.8215,
    x2: 37.3252,
    y2: 46.9406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_486_1491",
    x1: 37.3252,
    y1: 23.4704,
    x2: 37.3252,
    y2: 25.5892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_486_1491",
    x1: 43.4424,
    y1: 12.224,
    x2: 43.4424,
    y2: 14.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_486_1491",
    x1: 16.9502,
    y1: 2.0373,
    x2: 16.9502,
    y2: 4.15611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_486_1491",
    x1: 9.7783,
    y1: 18.3362,
    x2: 9.7783,
    y2: 20.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_486_1491",
    x1: 14.915,
    y1: 34.6349,
    x2: 14.915,
    y2: 36.7536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_486_1491",
    x1: 7.74269,
    y1: 40.7468,
    x2: 7.74269,
    y2: 42.8658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon9);
export default __webpack_public_path__ + "static/media/icon9.e79dd3050a68f8ca62b22650280e775b.svg";
export { ForwardRef as ReactComponent };